import React from 'react';
import classNames from 'classnames';
import Styles from './table-header.less';

const baseClass = Styles.thead;

module.exports = React.createClass({
  displayName: 'TableHeader',
  propTypes: {
    className: React.PropTypes.string
  },
  getChildren() {
    return React.Children.toArray(this.props.children)
      .filter(React.isValidElement)
      .filter(child => child.type.displayName == 'TableHeaderRow')
  },
  getClass() {
    return classNames(baseClass, this.props.className);
  },
  render: require('./table-header.rt')
});




/** WEBPACK FOOTER **
 ** ./src/table/table-header/table-header.js
 **/